export const isValidDate = (dateString) => {
  // UTC date format YYYY-MM-DD or YYYY-MM-DDT*
  const utcDatePattern = /^(\d{4}-\d{2}-\d{2})(?:T|$)/;

  return utcDatePattern.test(dateString);
};

export default isValidDate;
